// extracted by mini-css-extract-plugin
export var container = "_c2-0";